var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSlider = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "icon-slider_svg__cls-1",
  d: "M13.31 8.56a3.45 3.45 0 013.34 2.84H21a1.06 1.06 0 01.1 2.12h-4.45a3.44 3.44 0 01-3.34 2.83h-2.73a3.45 3.45 0 01-3.35-2.83H3.07a1 1 0 01-1-1.06A1.06 1.06 0 013 11.4h4.23a3.46 3.46 0 013.35-2.84zm0 .45h-2.73a3 3 0 00-3 2.93v.88a3.05 3.05 0 002.82 3.1h2.9a3 3 0 003-2.93v-.88A3 3 0 0013.47 9z"
})));

export default SvgIconSlider;